export default __webpack_public_path__ + "static/media/medicare-blue-guided.c71e4c26.png";